/**
 * CoevaluationInstructions Component
 *
 * Features:
 * - Displays step-by-step instructions for coevaluation process.
 * - Uses i18next for translations.
 * - Handles view change via changeViewHandler prop.
 * - Uses CSS modules for styling and Material-UI for UI.
 */
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import Button from '@mui/material/Button';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

import classes from './CoevaluationInstructions.module.css';

const CoevaluationInstructions = props => {
  const { t } = useTranslation(['lesson']);
  return (
    <>
      <div className={classes.activityContainer}>
        <aside className={classes.instructionsContainer}>
          <p className={classes.instructions__title}>
            {t('instructions')}:
          </p>
          <ol>
            <li className={classes.instructions__text}>
              {t('click_continue')}
            </li>
            <li className={classes.instructions__text}>
              {t('click_see_content')}
            </li>
            <li className={classes.instructions__text}>
              {t('click_empty_field')}
            </li>
            <li className={classes.instructions__text}>
              {t('feedback_comment')}
            </li>
          </ol>
        </aside>
      </div>
      <aside className={classes.btnsContainer}>
        {/* Props passed to Button:
            - onClick: props.changeViewHandler (function to change view)
            - className: classes.nextBtn
        */}
        <Button
          onClick={props.changeViewHandler}
          className={classes.nextBtn}
        >
          {t('continue')} <ChevronRightIcon />
        </Button>
      </aside>
    </>
  );
};

CoevaluationInstructions.propTypes = {
  /**
   * Function to change the view when the button is clicked
   */
  changeViewHandler: PropTypes.func,
  /**
   * Course ID
   */
  idCourse: PropTypes.number,
  /**
   * Lesson ID
   */
  idLesson: PropTypes.number,
  /**
   * Function to change the view (legacy, not used)
   */
  changeView: PropTypes.func
};

CoevaluationInstructions.defaultProps = {
  changeViewHandler: () => {},
  idCourse: null,
  idLesson: null,
  changeView: () => {}
};

export default CoevaluationInstructions;
